<template>
  <div v-if="loginUser">

    <b-alert show dismissible fade v-if="!loginUser.emailVerified" variant="warning" class="m-0 p-0 pt-1 pb-1 fontSizeDot9">
      {{ $t("tAlert.emailNotVerified") }}
      <b-button @click="busSendConfirmMail" size="sm" variant="primary" style="vertical-align: baseline; padding: 1px 5px 1px 5px;" class="m-0 ml-1 mr-1" >
        {{ $t("common.receiveConfirmMail") }}
      </b-button>
    </b-alert>

    <b-alert show dismissible fade v-if="loginUser.emailVerified && loginUser.photoURL == ''" variant="warning" class="m-0 p-0 pt-1 pb-1 fontSizeDot9">
      {{ $t("tAlert.userIconEmpty") }}
      <b-button size="small" variant="primary" style="vertical-align: baseline; padding: 1px 5px 1px 5px;" class="m-0 ml-1 mr-1" v-b-modal.editProfileFloat>
        {{ $t("tAlert.editIcon") }}
      </b-button>
    </b-alert>

  </div>
</template>
<script>
import eventBus from '@/plugins/eventBus.js'
import { mapState } from "vuex"
import { mapSetter } from "@/plugins/vuexUtils.js"
export default {
  name: "tAlert",
  methods: {
    busSendConfirmMail: function() {
      eventBus.$emit('busSendConfirmMail')
    },
  },
  computed: {
    ...mapSetter(
      mapState({
        loginUser: state => state.loginUser,
      })
    )
  }
}
</script>
<style scoped>
</style>
